import { Injectable, inject } from '@angular/core';
import { DataWarehouseResponse } from '@app/core/models/sales-competition.model';
import { ApiBaseService } from '@app/core/services/api-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DatawareApiService {
  readonly #API_PATH_DW: string = 'api/dw';
  readonly #apiBaseService = inject(ApiBaseService);

  getSalesCompetitionResult(
    svfAccount: number,
    networkAlias: string
  ): Observable<DataWarehouseResponse> {
    const uri = `CheckSalesCompetitionResult?svfAccount=${svfAccount}&networkAlias=${networkAlias}`;
    return this.#apiBaseService.dwGet(this.#API_PATH_DW, uri);
  }
}
